import { CollectionModel, customerApi, QueryTag } from '../api';
import { useMemo } from 'react';

export interface ConfigurationGroupBasicModel {
  id: number;
  name: string;
}

export const configurationGroupsApi = customerApi.injectEndpoints({
  endpoints: build => ({
    getConfigurationGroups: build.query<ConfigurationGroupBasicModel[], void>({
      query: () => 'api/configGroups',
      transformResponse: (response: CollectionModel<ConfigurationGroupBasicModel>) =>
        response.items,
      providesTags: (result, error, arg) =>
        result ? [QueryTag.SiteCache, { type: QueryTag.ConfigGroup, id: 'CONFIGGROUPS' }] : [],
    }),
  }),
  overrideExisting: false,
});

export const { useGetConfigurationGroupsQuery } = configurationGroupsApi;

export const useGetConfigurationGroupName = (configGroupId?: number): string | undefined => {
  const { data: configGroups } = useGetConfigurationGroupsQuery(undefined, {
    refetchOnMountOrArgChange: 60,
  });

  return useMemo(() => {
    if (configGroupId) {
      const match = configGroups?.find(c => c.id === configGroupId);
      if (match) {
        return match.name;
      }
    }

    return undefined;
  }, [configGroupId, configGroups]);
};
